module.exports = __webpack_public_path__ + "static/img/sonarqube_logo.c3c9cb4.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/sonarqube_logo.jpeg
// module id = wna7
// module chunks = 2